import React from "react";
import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";

import { colors } from "../dark-hero/colors";
import { PageContainer } from "../dark-hero/PageContainer";
import { HOW_THIS_WORKS, MATCH_NIGHT_CADENCE } from "./honest-buildContent";
import { BODY_SX, LABEL_SX, REVEAL, SECTION_SX, TITLE_SX } from "./sectionStyles";

const MotionBox = motion(Box);

const pointsSx = {
  display: "flex",
  flexDirection: "column",
  gap: { xs: 2.5, md: 3 },
  maxWidth: "40rem",
  mt: { xs: "2.5rem", md: "3.5rem" },
};

const pointTitleSx = {
  fontFamily: "'Inter', system-ui, sans-serif",
  fontSize: "1.05rem",
  fontWeight: 700,
  color: colors.text.primary,
  mb: 0.5,
};

const pointBodySx = {
  fontSize: "0.95rem",
  lineHeight: 1.7,
  color: colors.text.secondary,
};

export default function HowThisWorksNow() {
  return (
    <Box component="section" sx={SECTION_SX}>
      <PageContainer sx={{ maxWidth: "75rem" }}>
        <MotionBox {...REVEAL} transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}>
          <Typography component="div" sx={LABEL_SX}>
            {HOW_THIS_WORKS.eyebrow}
          </Typography>
          <Typography component="h2" sx={TITLE_SX}>
            How this works <span>{HOW_THIS_WORKS.titleAccent}</span>
          </Typography>
          <Typography sx={{ ...BODY_SX, mt: 2 }}>{HOW_THIS_WORKS.intro}</Typography>
          {MATCH_NIGHT_CADENCE ? (
            <Typography sx={{ ...BODY_SX, mt: 1.5 }}>
              Usual time: {MATCH_NIGHT_CADENCE}.
            </Typography>
          ) : null}
        </MotionBox>
        <Box sx={pointsSx}>
          {HOW_THIS_WORKS.points.map((point, index) => (
            <MotionBox
              key={point.title}
              {...REVEAL}
              transition={{ duration: 0.9, delay: index * 0.08, ease: [0.22, 1, 0.36, 1] }}
            >
              <Typography sx={pointTitleSx}>{point.title}</Typography>
              <Typography sx={pointBodySx}>{point.body}</Typography>
            </MotionBox>
          ))}
        </Box>
      </PageContainer>
    </Box>
  );
}
